import { NgModule } from '@angular/core';
import { AlarmListComponent } from './alarm-list/alarm-list.component';
import { SharedProviderModule } from '../shared/shared.module';
import { QmPipesModule } from '../components/qm-pipes/qm-pipes.module';
import { QmDirectivesModule } from '../components/qm-directives/qm-directives.module';
import { AlarmService } from './alarm.service';
import { OverlayPanelModule } from '../components/overlay-panel/overlay-panel.module';
import { AlarmComponent } from './alarm.component';
import { ElementUtilsModule } from '../element-utils/element-utils.module';
import { TranslateModule } from '@ngx-translate/core';
import { AlarmDiagramComponent } from './alarm-diagram/alarm-diagram.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FiltersModule } from '../sidebar/filters/filters.module';
import { NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ApplyFunctionPipe } from '../components/qm-pipes/apply-function-pipe/apply-function.pipe';
import { VrgroupModule } from '../custom/vrgroup/vrgroup.module';
import { FontAwesomeIconsModule } from '../fontawesome-icons.module';
import { AlarmItemMenuComponent } from './alarm-item-menu/alarm-item-menu.component';

@NgModule({
  imports: [
    ElementUtilsModule,
    OverlayPanelModule,
    QmPipesModule,
    QmDirectivesModule,
    SharedProviderModule,
    TranslateModule,
    NgxChartsModule,
    FiltersModule,
    NgbPaginationModule,
    NgbTooltipModule,
    VrgroupModule,
    FontAwesomeIconsModule
  ],
  declarations: [AlarmListComponent, AlarmComponent, AlarmDiagramComponent, AlarmItemMenuComponent],
  exports: [AlarmListComponent, AlarmComponent, AlarmDiagramComponent],
  providers: [AlarmService]
})
export class AlarmModule { }
